// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.screenings {
  grid-template-columns: repeat(11, auto);
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/screenings-draft-list/screenings-draft-list.component.less"],"names":[],"mappings":"AAEA;EACI,uCAAA;AADJ","sourcesContent":["@import (reference) '../../../styles.less';\n\n.grid.screenings {\n    grid-template-columns: repeat(11, auto);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
